import React from 'react';
import { string, shape } from 'prop-types';
import Product from 'components/Product';
import styles from './styles';

function ProductTeaser(props) {
  const { titleHtml, product } = props;

  if (!product) {
    return null;
  }

  return (
    <div className="ProductTeaser">
      {titleHtml && (
        <div
          className="ProductTeaser__heading"
          dangerouslySetInnerHTML={{ __html: titleHtml }}
        />
      )}

      <Product {...product} />

      <style jsx>{styles}</style>
    </div>
  );
}

ProductTeaser.propTypes = {
  titleHtml: string,
  product: shape()
};

ProductTeaser.defaultProps = {
  titleHtml: undefined,
  product: undefined
};

export default ProductTeaser;
